import { ToastrService } from 'ngx-toastr';
import { Store } from './../../store';
import { Router } from '@angular/router';
import { GalleryService } from './../gallery.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-galleries',
    templateUrl: './galleries.component.html',
    styleUrls: ['./galleries.component.scss']
})
export class GalleriesComponent implements OnInit {

    items = [];
    itemToDelete;

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    constructor(
        private galleryService: GalleryService,
        private router: Router,
        private store: Store,
        private toastrService: ToastrService,
    ) {
        this.getAll();
    }

    ngOnInit(): void {
    }

    getAll() {
        this.galleryService.getAll().subscribe(data => {
            this.items = data.data;
        });
    }

    create() {
        this.router.navigate(['/cms', 'galleries', 'new']);
    }

    update(gallery) {
        this.router.navigate(['/cms', 'galleries', gallery.id]);
    }

    setStatus(gallery) {
        if (gallery.status === 1) {
            gallery.status = 0;
        } else {
            gallery.status = 1;
        }
        this.galleryService.update(gallery).subscribe();
    }

    deleteConfirm(gallery) {
        this.confirmationData.title = 'Please confirm you would like to delete this gallery';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
        this.itemToDelete = gallery;
    }
    confirmAction(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.galleryService.delete(this.itemToDelete.id).subscribe(data => {
                this.toastrService.success('Gallery deleted');
                this.getAll();
            });
        }
        this.confirmationData.open = false;
    }

}
